var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogCancelCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#999CA2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5669 6.43306C13.811 6.67714 13.811 7.07286 13.5669 7.31694L7.31694 13.5669C7.07286 13.811 6.67714 13.811 6.43306 13.5669C6.18898 13.3229 6.18898 12.9271 6.43306 12.6831L12.6831 6.43306C12.9271 6.18898 13.3229 6.18898 13.5669 6.43306Z",
    fill: "#999CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43306 6.43306C6.67714 6.18898 7.07286 6.18898 7.31694 6.43306L13.5669 12.6831C13.811 12.9271 13.811 13.3229 13.5669 13.5669C13.3229 13.811 12.9271 13.811 12.6831 13.5669L6.43306 7.31694C6.18898 7.07286 6.18898 6.67714 6.43306 6.43306Z",
    fill: "#999CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogCancelCircle);
export default __webpack_public_path__ + "static/media/dialog-cancel-circle.ee39eff8d9add8f259f686e65a9b7bb4.svg";
export { ForwardRef as ReactComponent };